import { createSlice } from '@reduxjs/toolkit'

const tpoSlice = createSlice({
  name: 'tpo',
  initialState: {
    urgentCount: 0,
    hasShownPopup: false, // Add a flag to track popup visibility
  },
  reducers: {
    setUrgentCount: (state, action) => {
      state.urgentCount = action.payload
    },
    setHasShownPopup: (state, action) => {
      state.hasShownPopup = action.payload
    },
  },
})

export const { setUrgentCount, setHasShownPopup } = tpoSlice.actions
export default tpoSlice.reducer
